<div class="selection-section location-toolbar">
  <div class="selection-field">
    <span class="selection-label">Location</span>
    <app-simple-dropdown
      [options]="locationOptions"
      [selectedValue]="selectedLocationId"
      [title]="locationsLoading ? 'Loading locations…' : 'Select a location'"
      [placeholder]="'Select a location'"
      [isOpen]="isLocationDropdownOpen"
      [disabled]="locationsLoading || !hasLocations"
      (selectionChange)="onLocationPicked($event)"
      (toggle)="toggleLocationDropdown()"
      (close)="closeLocationDropdown()"
    >
    </app-simple-dropdown>
  </div>
</div>

@if (selectedLocationId) {
  <div class="settings-tabs" role="tablist" aria-label="Location settings sections">
    @for (tab of tabs; track tab.id) {
      <button
        type="button"
        class="settings-tab"
        role="tab"
        [attr.aria-selected]="activeTab === tab.id"
        [class.active]="activeTab === tab.id"
        (click)="selectTab(tab.id)"
      >
        {{ tab.label }}
        @let count = tabCount(tab.id);
        @if (count !== null) {
          <span
            class="tab-count"
            [class.tab-count--zero]="count === 0"
            [attr.aria-label]="count + ' ' + tabCountLabel(tab.id)"
            >{{ count }}</span
          >
        }
      </button>
    }
  </div>

  <div [hidden]="activeTab !== 'lanes'" role="tabpanel">
    <app-location-lanes
      [companyId]="companyId"
      [locationId]="selectedLocationId"
      [active]="activeTab === 'lanes'"
      (activeCountChange)="onLaneCountChange($event)"
    >
    </app-location-lanes>
  </div>

  <div [hidden]="activeTab !== 'tunnel'" role="tabpanel">
    <app-location-tunnel
      [companyId]="companyId"
      [locationId]="selectedLocationId"
      (activeCountChange)="onTunnelPackageCountChange($event)"
    >
    </app-location-tunnel>
  </div>

  <div [hidden]="activeTab !== 'way'" role="tabpanel">
    <app-location-way
      [companyId]="companyId"
      [location]="selectedLocation"
      (locationUpdated)="onLocationUpdated($event)"
    >
    </app-location-way>
  </div>
} @else if (!locationsLoading) {
  <div class="empty-state-container page-empty">
    <app-empty-result
      image="/assets/images/empty_screen.png"
      [title]="hasLocations ? 'Select a location' : 'No locations'"
      [description]="
        hasLocations
          ? 'Choose a location to manage its lanes, tunnel and Way settings.'
          : 'This company has no locations yet.'
      "
      [actionText]="''"
      [showAction]="false"
    >
    </app-empty-result>
  </div>
}
